import React from "react";

import logo_ad from "../assete/logo/LOGO-min.png";

const Newhead = () => {
  return (
    <div className="header_main_div_list">
          <div className='admin_header_main_div'>
            <div className='admin_header_div'>
                <img src={logo_ad} alt=""/>
            </div>
           
          </div>
        </div>
  );
};

export default Newhead;
